// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_iF","title":"_iG","links":"_iH","item":"_iI"};